import React, { useContext, useEffect, useRef } from 'react';
import styles from './Cover.module.scss';
import PathContext from '../../context/path';
import Figure from '../Figure';
import Button from '../Button';

const MainCover = () => {
  const path = useContext(PathContext);
  const refContruction = useRef(null);

  useEffect(() => {
    const wrap = refContruction.current;
    let options = {
      threshold: 0,
      rootMargin: '0% 0% 0% 0%',
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add(styles.constructions_animate);
          observer.unobserve(entry.target);
        }
      });
    }, options);
    observer.observe(wrap);
    return () => {
      observer.unobserve(wrap);
    };
  }, []);

  const clickHandler = (anchor) => {
    if (document.querySelector(`[data-anchor='${anchor}']`) !== null) {
      document
        .querySelector(`[data-anchor='${anchor}']`)
        .scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.logo}>
          <picture>
            <source
              media="screen and (max-width: 767px)"
              srcSet={`${path}/img/logo-mobile.svg`}
            />
            <img src={`${path}/img/logo.svg`} alt="" />
          </picture>
        </div>
        <div className={styles.figure}></div>

        <h1 className={styles.title}>
          Р-Фарм —
          <br /> люди действия
        </h1>

        <div className={styles.links}>
          <Button
            className={styles.links__btn}
            design="green"
            size="large"
            onClick={() => {
              clickHandler('invite');
            }}
          >
            Вакансии
          </Button>
          <Button
            className={styles.links__btn}
            design="green-outline"
            size="large"
            onClick={() => {
              clickHandler('about');
            }}
          >
            О нас
          </Button>
          <Button
            className={styles.links__btn}
            design="green-outline"
            size="large"
            onClick={() => {
              clickHandler('stories');
            }}
          >
            Истории
          </Button>
        </div>

        <div className={styles.menu}>
          <div className={`${styles.item} ${styles.item_1}`}>
            <Figure
              color={'green_light'}
              opacity={0.9}
              form={'circle'}
            ></Figure>
          </div>
          <div className={`${styles.item} ${styles.item_2}`}>
            <Figure bg={'green-rhombus.svg'} opacity={0.9}></Figure>
          </div>
          <div className={`${styles.item} ${styles.item_3}`}>
            <Figure bg={'yellow-star.svg'} opacity={0.9}></Figure>
          </div>
        </div>

        <div className={styles.constructions} ref={refContruction}>
          <div className={styles.constructions__row}>
            <div className={`${styles.construct} ${styles.construct_1}`}>
              <Figure bg={'transparent-saw-main.svg'}>
                <div className={styles.construct__text}>Р-Фарм</div>
              </Figure>
            </div>
            <div className={`${styles.construct} ${styles.construct_2}`}>
              <Figure color={'green'} form={'circle'}></Figure>
            </div>
            <div className={`${styles.construct} ${styles.construct_3}`}>
              <Figure color={'pink'} form={'rect'}>
                <div className={styles.construct__text}>
                  приглашает специалистов
                </div>
              </Figure>
            </div>
            <div className={`${styles.construct} ${styles.construct_4}`}>
              <Figure bg={'transparent-triangle.svg'}></Figure>
            </div>
          </div>

          <div className={styles.constructions__row}>
            <div className={`${styles.construct} ${styles.construct_5}`}>
              <Figure color={'border'}>
                <div className={styles.construct__text}>в свою команду</div>
              </Figure>
            </div>
            <div className={`${styles.construct} ${styles.construct_6}`}>
              <Figure bg={'green-light-rhombus.svg'}></Figure>
            </div>
            <div className={`${styles.construct} ${styles.construct_7}`}>
              <Figure
                bg={'transparent-saw-square.svg'}
                rotate={'fade-in-up'}
              ></Figure>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainCover;
